<template>
  <layout>
    <div slot="content">
      <i-card title="船票套餐">
        <div slot="content">
          <el-table
            v-loading="loading"
            :border="true"
            :highlight-current-row="true"
            :data="shipList"
            style="width: 100%">
            <el-table-column
              prop="id"
              label="产品ID"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="cover_pic"
              label="封面图片"
              width="110"
            >
              <el-image  slot-scope="scope" lazy style="width: 80px; height: 80px;border:1px solid #eee;border-radius: 10px" :preview-src-list="[scope.row.cover_pic]" :src="scope.row.cover_pic" fit="cover"/>
            </el-table-column>
            <el-table-column
              prop="title"
              label="套餐名称"
            >
            </el-table-column>
            <el-table-column
              prop="sale_count"
              label="销量"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="list_order"
              label="排序"
              width="80"
            >
            </el-table-column>
            <el-table-column
              label="销售状态"
              width="100"
            >
              <template slot-scope="scope">
                <el-tag size="mini" type="success" v-if="scope.row.on_sale === 1">销售中</el-tag>
                <el-tag size="mini" type="danger" v-else>已下架</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="创建时间"
              width="160"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="400"
              fixed="right"
            >
              <div style="text-align: center" slot-scope="scope">
                <router-link :to="{name:'product.edit_ship',query:{product_id:scope.row.id}}">
                  <el-button size="mini" type="primary">编辑</el-button>
                </router-link>
                <el-button size="mini" type="primary"
                           @click="setDistribution(scope.row.id)">
                  分销
                </el-button>
                <el-button size="mini" type="primary" style="margin-top: 0"
                           @click="getSailingsList(scope.row.id)">绑定航班
                </el-button>
                <el-button size="mini" type="primary" style="margin-top: 0" @click="setExtension(scope.row.id,scope.row.title)"
                >扩展设置
                </el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <router-link :to="{name:'product.add_ship'}">
            <el-button type="success" size="medium" icon="el-icon-plus">新建船票套餐</el-button>
          </router-link>
        </div>
      </i-card>
      <i-fx :show="showFxStatus" :product-id="currProductId" @change="showFx"></i-fx>
      <i-extension :show="showExtensionStatus" :product-id="currProductId" :goods-title="currGoodsTitle" @change="showExtension"></i-extension>
      <el-dialog
        title="绑定航班"
        :visible.sync="bindSailingsDialog"
        :append-to-body="true"
        width="50%"
      >
        <el-table
          ref="sailingsTable"
          :data="sailingsList"
          tooltip-effect="dark"
          @selection-change="getInfo"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            label="航班名称"
            prop="sailings_title"
          >
          </el-table-column>
          <el-table-column
            prop="sailings_code"
            label="航班号"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="时间信息"
          >
            <div slot-scope="scope">
              {{scope.row.start_time}} - {{scope.row.end_time}}
            </div>
          </el-table-column>
          <el-table-column
            prop="address"
            label="码头信息"
          >
            <div slot-scope="scope">
              {{scope.row.start_wharf}} - {{scope.row.end_wharf}}
            </div>
          </el-table-column>
          <el-table-column
            label="销售状态"
            width="80"
          >
            <template slot-scope="scope">
              <el-tag size="mini" type="success" v-if="scope.row.on_sale === 1">销售中</el-tag>
              <el-tag size="mini" type="danger" v-else>已下架</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="bindSailingsDialog = false">取 消</el-button>
          <el-button type="primary" :loading="bindSailingsLoading" @click="postBind">确
            定
          </el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
  import iFx from "@/components/i-fenxiao"
  import iExtension from "@/components/i-extension"

  export default {
    name: "ship",
    components: {iFx, iExtension},
    data() {
      return {
        shipList: [],
        loading: false,
        dialogVisible: false,
        distributionInfo: ['', ''],
        currUnicode: '',
        currProductId: '',
        currGoodsTitle: '',
        showFxStatus: false,
        distributionLoading: false,
        bindSailingsDialog: false,
        bindSailingsLoading: false,
        selectedSailings: "",
        sailingsList: [],
        currShipId: "",
        showExtensionStatus: false,
      }
    },
    methods: {
      setDistribution: function (productId) {
        this.showFxStatus = true;
        this.currProductId = productId;
      },
      showFx: function (show) {
        this.showFxStatus = show;
      },
      setExtension: function (productId,title) {
        this.showExtensionStatus = true;
        this.currProductId = productId;
        this.currGoodsTitle  = title;
      },
      showExtension:function (show) {
        this.showExtensionStatus = show;
      },
      getShipList: function () {
        let _self = this;
        this.loading = true;
        this.$http.request('productList',{type:11}).then((res) => {
          _self.shipList = res.data;
          _self.loading = false;
        });
      },
      getSailingsList: function (shipId) {
        this.bindSailingsDialog = true;
        this.sailingsList = [];
        this.currShipId = shipId;
        this.$http.request('bindSingsList', {ship_id: shipId}).then((res) => {
          this.sailingsList = res.data.sailings;
          this.sailingsList.forEach((row) => {
            res.data.binds.forEach((bindRow) => {
              if (bindRow.id === row.id) {
                this.$nextTick(() => {
                  this.$refs.sailingsTable.toggleRowSelection(row)
                });
              }
            });

          })
        });
      },
      getInfo(val) {
        this.selectedSailings = "";
        val.forEach((row) => {
          this.selectedSailings += row.id + ",";
        });
      },
      postBind: function () {
        this.bindSailingsLoading = true;
        this.$http.request('doBindSailings', {
          ship_id: this.currShipId,
          sailingIds: this.selectedSailings
        }).then((res) => {
          this.bindSailingsLoading = false;
          this.bindSailingsDialog = false;
          this.$message({
            message: res.message,
            type: 'success'
          });
        });
      },
      delProduct:function (id) {
        this.$confirm('是否删除该商品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.request('delProduct', {product_id: id}).then((res) => {
            let _self = this;
            if (res.status === 'success') {
              this.$message({
                type: 'success',
                message: res.message,
                onClose: function () {
                  _self.getShipList();
                }
              });
            }
          });
        })
      }
    },
    created: function () {
      this.getShipList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/ship.vue